// extracted by mini-css-extract-plugin
export default {"root":"BrandDropdown_root__hzrHS","dropdownInput":"BrandDropdown_dropdownInput__2fDdw"};